// extracted by mini-css-extract-plugin
export default {"showMoreButton":"PjydGR","showMoreButtonContainer":"JNSF8q"};